import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '24',
  height: '23',
  viewBox: '0 0 24 23'
}, [
  h('path', {
    d: 'M20.5 23h-6c-.3 0-.5-.2-.5-.5V16h-4v6.5c0 .3-.2.5-.5.5h-6c-.3 0-.5-.2-.5-.5v-10c0-.3.2-.5.5-.5s.5.2.5.5V22h5v-6.5c0-.3.2-.5.5-.5h5c.3 0 .5.2.5.5V22h5v-9c0-.3.2-.5.5-.5s.5.2.5.5v9.5c0 .3-.2.5-.5.5z'
  }),
  h('path', {
    d: 'M23.5 12.5c-.1 0-.3 0-.4-.1L12 1.2.9 12.4c-.2.2-.5.2-.7 0s-.2-.5 0-.7L11.6.1c.2-.2.5-.2.7 0l11.5 11.5c.2.2.2.5 0 .7 0 .2-.2.2-.3.2zM19.5 5.5c-.3 0-.5-.2-.5-.5V2h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.5c.3 0 .5.2.5.5V5c0 .3-.2.5-.5.5z'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/nav-home.es6.js